// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FPJh","label":"styles_label__1ABMo"};